/**
 * Created by Shreedhar Acharya
 * https://marvelapp.com/43fgc52/screen/54180754
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import filter from 'ramda/src/filter';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import CheckIcon from '@components/@core/CheckIcon';
import Rating from '@components/@core/Rating';
import { UserRoles, AdminDotsType, UserDotsType } from '~/services/config';
import { quotaCalc } from '~/services/util';

const ListCard = ({ userRole, data, title, onSelect }) => {
    let dotsMenu = userRole > UserRoles.MANAGER ? UserDotsType : AdminDotsType;
    dotsMenu = filter((x) => x !== 'Preview View', dotsMenu);
    return (
        <div className="assignment-quota-card" data-cy="qutoaListCard">
            <p className="dsl-b18 bold mb-1">{title} Quotas</p>
            <div className="card-item pt-2 py-3">
                <div className={cx('d-flex-3 d-flex-sm-1', title === 'Program' && 'd-flex-md-8')}>
                    <p className="dsl-m12 text-400 m-0">Goals</p>
                </div>
                <div className="d-flex-2 d-flex-sm-1">
                    <p className="dsl-m12 text-400 m-0">{title === 'Scorecard' ? 'Scale' : 'Calculation'}</p>
                </div>
                <div className="d-flex-1 text-start ps-1">
                    <p className={cx('dsl-m12 text-400 m-0', title === 'Program' && 'desktop-only')}>Actual</p>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 text-400 m-0 ps-2 ps-md-0">{title === 'Scorecard' ? 'Score' : 'Status'}</p>
                </div>
                <div className="w-10 d-sm-none" />
            </div>
            {isEmpty(data) ? (
                <div className="card-item border-top">
                    <div className="d-flex d-flex-8 d-flex-sm-1">
                        <span className="dsl-b12 text-400">No Quotas Assigned</span>
                    </div>
                    <div className="d-flex-2">
                        <p className="dsl-m12 text-400 m-0">Na</p>
                    </div>
                    <div className="d-flex-1 text-center">
                        <p className="dsl-m12 text-400 m-0">Na</p>
                    </div>
                    <div className="d-flex-1">
                        <p className="dsl-m12 text-400 m-0 ps-2 ps-md-0">Na</p>
                    </div>
                    <div className="w-10 d-sm-none" />
                </div>
            ) : (
                data.map((quota) => (
                    <div className="card-item border-top" key={quota.id}>
                        {title === 'Scorecard' ? (
                            <div className="d-flex-3 d-flex-sm-1">
                                <p className="dsl-b12 text-400 m-0 word-break">{quota.data.name || quota.name}</p>
                            </div>
                        ) : (
                            <div className="d-flex d-flex-8 d-flex-sm-1">
                                <div className="w-5">
                                    <CheckIcon size={26} checked={!isNil(quota.completed_at)} />
                                </div>
                                <div className="d-flex-3 ps-4">
                                    <p className="dsl-b14 text-400 m-0">{quota.data.name || quota.name}</p>
                                    <p className="dsl-m12 text-400 m-0">{quota.data.description}</p>
                                </div>
                            </div>
                        )}
                        {title === 'Scorecard' ? (
                            <div className="d-flex-2 text-end scale-info">
                                <Rating title={quota.data.star_values[0]} className="mb-2 pb-2" score={5} />
                                <Rating title={quota.data.star_values[2]} className="mb-2 pb-2" score={4} />
                                <Rating title={quota.data.star_values[3]} className="mb-2 pb-2" score={2} />
                            </div>
                        ) : (
                            <div className="d-flex-2 text-start">
                                <p className="dsl-b14 text-400"> {quota.data.quota_calculation}</p>
                            </div>
                        )}
                        <div className={cx('d-flex-1 text-start ps-1', title === 'Program' && 'desktop-only')}>
                            <p className="dsl-b14 text-400">{quota.actuals[0] ? quota.actuals[0].actual : 0}</p>
                        </div>
                        <div className="d-flex-1 d-flex-sm-2 text-start">
                            {title === 'Scorecard' ? (
                                <Rating className="mb-2 pb-2" score={quotaCalc(quota, quota.actuals[0]?.actual ?? 0)} />
                            ) : (
                                <p className="dsl-b14 text-400">{quota?.data?.quota_value}</p>
                            )}
                        </div>
                        <div className="w-10 d-sm-none">{/* <EditDropdown options={dotsMenu} onChange={e => onSelect(e, quota)} /> */}</div>
                    </div>
                ))
            )}
        </div>
    );
};

ListCard.propTypes = {
    userRole: PropTypes.number,
    userId: PropTypes.number,
    data: PropTypes.any,
    onSelect: PropTypes.func,
};

ListCard.defaultProps = {
    userRole: 1,
    userId: 0,
    data: {},
    onSelect: () => {},
};

export default memo(ListCard);
